import styles from './ImagePreview.module.css';

interface ImagePreviewProps {
  imageUrl: string;
  onClose: () => void;
}

export const ImagePreview: React.FC<ImagePreviewProps> = ({ imageUrl, onClose }) => {
  return (
    <div className={styles.overlay} onClick={onClose}>
      <button className={styles.closeBtn} onClick={onClose}>&times;</button>
      <div className={styles.imageWrapper} onClick={(e) => e.stopPropagation()}>
        <img src={imageUrl} alt="Preview" />
      </div>
    </div>
  );
};
